import { Link } from 'react-router-dom';
import { useI18n } from '@/features/i18n/I18nProvider';
import { getSubscriptionAlert, planLabel } from '@/features/subscription/access';
import { useAccessState } from '@/features/subscription/RequireFeatureAccess';

export function SubscriptionAlertBanner() {
  const { t, locale } = useI18n();
  const { state, subscription } = useAccessState();
  const alert = getSubscriptionAlert(state, subscription);

  if (!alert) return null;

  const isWarning = alert.kind === 'installment_due' && alert.overdue;

  let message: string;
  switch (alert.kind) {
    case 'trial_expiring':
      message = t('sub.alertTrialExpiring', { days: alert.daysLeft });
      break;
    case 'subscription_expiring':
      message = t('sub.alertSubscriptionExpiring', {
        days: alert.daysLeft,
        plan: planLabel(alert.planKey, locale),
      });
      break;
    case 'installment_due':
      message = alert.overdue
        ? t('sub.alertInstallmentOverdue')
        : alert.daysLeft === 0
          ? t('sub.alertInstallmentDueToday')
          : t('sub.alertInstallmentDueSoon', { days: alert.daysLeft });
      break;
  }

  return (
    <div className={`${isWarning ? 'error-banner' : 'warning-banner'} subscription-alert-banner`}>
      <span>{message}</span>
      <Link className="subscription-alert-link" to="/app/abonnement">
        {t('sub.alertAction')}
      </Link>
    </div>
  );
}
